var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 96.034V415.969C512 433.641 497.674 447.968 480.001 447.968H480.001C462.327 447.968 448 433.64 448 415.966V284.12L276.5 440.594C255.875 457.716 224 443.343 224 415.973V284.12L52.5 440.594C31.875 457.716 0 443.343 0 415.973V96.027C0 68.657 31.875 54.284 52.5 71.406L224 226.755V96.027C224 68.657 255.875 54.284 276.5 71.406L448 226.755V96.031C448 78.359 462.326 64.032 479.999 64.032H479.999C497.673 64.032 512 78.36 512 96.034Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardFast);
export default __webpack_public_path__ + "static/media/forward-fast.1ad9cb3e36ee9038889dfe4db09630db.svg";
export { ForwardRef as ReactComponent };